import React, { useMemo } from 'react';
import { collect } from 'collect.js';
import Modifier from './Modifier';
import { useHelpers } from '../../providers/HelpersProvider';

export default function OrderLineItem({ lineItem, isLastItem }) {
  const { formatCurrency, formatProductName } = useHelpers();

  const { modifiers } = lineItem;
  const modifiersByParent = useMemo(() => collect(modifiers).groupBy('parent_uuid'), [modifiers]);
  const rootModifiers = useMemo(() => modifiersByParent.get(''), [modifiersByParent]);

  const renderModifier = (item, parentQuantity, isNested = false) => {
    const quantity = parentQuantity * item.quantity;
    const price = quantity * item.actual_price;

    return (
      <div key={item.uuid} className="space-y-xs">
        <Modifier name={item.name} price={price} quantity={quantity} isNested={isNested} />
        {renderNestedModifiers(item.uuid, parentQuantity * item.quantity)}
      </div>
    );
  };

  const renderNestedModifiers = (parentUuid, parentQuantity) => {
    const nestedModifiers = modifiersByParent.get(parentUuid);

    if (!nestedModifiers?.count()) {
      return;
    }

    return (
      <div className="ml-md space-y-xs">
        {nestedModifiers.map((modifier) => renderModifier(modifier, parentQuantity * modifier.quantity, true))}
      </div>
    );
  };

  return (
    <div>
      <div className="grid grid-cols-12 gap-xs">
        <span className="font-semibold">{lineItem.quantity}x</span>
        <span className="col-span-8 md:col-span-9 font-semibold break-words">{formatProductName(lineItem)}</span>
        <span className="col-span-3 md:col-span-2 text-right">{formatCurrency(lineItem.product_actual_price)}</span>
      </div>
      {rootModifiers?.map((item) => renderModifier(item, lineItem.quantity))}
      {lineItem.note && (
        <div className="grid grid-cols-12 gap-xs">
          <span />
          <span className="col-span-11 italic">{lineItem.note}</span>
        </div>
      )}
      {!isLastItem && <hr className="w-full mt-2 mb-0 bg-silver h-[1px]" />}
    </div>
  );
}
